module.exports = __webpack_public_path__ + "img/dream-journal_B095GL6QTP.defa9610.jpg";